import { Component, Input, NgZone, OnInit, ViewChild, ElementRef } from '@angular/core';
import { GlobalMethodsService } from 'src/app/services/global-methods.service';
import { NavigationService } from '../../services/commons/navigation.service';
import { TimerService } from '../../services/commons/timer.service';
import { IonHeader, ModalController } from '@ionic/angular';
import { NewsPresentationComponent } from '../modals/news-presentation/news-presentation.component';
import { CardNew } from '../../models/CardNew';
import { GlobalVariablesService } from '../../services/global-variables.service';
import { StorageService } from '../../services/commons/storage.service';
import { NewsService } from '../../services/commons/news.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input('alarmActivated') alarmActivated: boolean = false;
  @Input('timerRunning') timerRunning: boolean = false;
  @Input('newFeaturesAvailable') newFeaturesAvailable: boolean = false;
  @Input('user') user: string;
  public showSearcher: boolean = true;
  @ViewChild('searcher') searcher: any;
  public pendingMessages = 0;
  public isServiceBusy = false;
  public cardsNews: CardNew [] = [];

  async changeDesign(event) {
    if (event.url.includes('profile')) {
      if (event.activate) {
        this.searcher.el.style = 'background: transparent !important';
      } else {
        this.searcher.el.style = 'background: #FFFFFF !important';
      }
    }
  }

  constructor(public gms: GlobalMethodsService,
    private zone: NgZone,
    public timerService: TimerService,
    private modalCtrl: ModalController,
    public gvs: GlobalVariablesService,
    private storage: StorageService,
    public navigation: NavigationService,
    private newsService: NewsService,
    public router: Router) {
    this.gms.setupPageEvent().subscribe((setupPage) => {
      this.zone.run(async () => {
        this.showSearcher = setupPage.showSearcher;
        if(this.router.url.includes('/geo-around')){
          this.searcher.el.style = 'background: transparent !important';
        }else{
          this.searcher.el.style = 'background: rgba(79,79,79,.1)';
        }
      });
    });

    this.gms.headerChatNotifCall$.subscribe(async reception => {
      if (reception > 0) {
        this.pendingMessages = this.pendingMessages + reception;
      } else {
        this.pendingMessages = 0;
      }
    });
  }

  async ngOnInit() {
  }

  headToAlarm() {
    this.modalCtrl.dismiss(false);
    this.navigation.goTo("/alarm");
  }

  async visualizeNews() {
    if (this.isServiceBusy) {
      return;
    }
    this.isServiceBusy = true;
    let modal = await this.newsService.checkCardsNews('header');
    if(modal != null){
      modal.onDidDismiss().then(response => {
        this.zone.run(async () => {
          this.cardsNews = await this.storage.getObject(this.gvs.CARDS_NEWS);
          this.gms.setStatusNewsPanel(this.cardsNews.filter(x => x.visible).length > 0 ? true : false);
        })
      });
    }
    this.isServiceBusy = false;
  }

  async closeComponent(){
    this.newFeaturesAvailable = false;
    this.gms.setStatusNewsPanel(false);
  }

}
